import { useEffect } from 'react';
import { useLayoutSlots } from '@app/layouts/layoutContext';
import styles from './textPages.module.css';

const LICENSES = [
  { name: 'React', license: 'MIT', url: 'https://github.com/facebook/react' },
  { name: 'Vite', license: 'MIT', url: 'https://github.com/vitejs/vite' },
  { name: 'React Router', license: 'MIT', url: 'https://github.com/remix-run/react-router' },
  { name: 'Zustand', license: 'MIT', url: 'https://github.com/pmndrs/zustand' },
  { name: 'Motion', license: 'MIT', url: 'https://github.com/motiondivision/motion' },
  { name: '@use-gesture/react', license: 'MIT', url: 'https://github.com/pmndrs/use-gesture' },
  { name: 'Workbox', license: 'MIT', url: 'https://github.com/GoogleChrome/workbox' },
  { name: 'Syne', license: 'OFL', url: 'https://fonts.google.com/specimen/Syne' },
  { name: 'DM Sans', license: 'OFL', url: 'https://fonts.google.com/specimen/DM+Sans' },
  { name: 'DM Mono', license: 'OFL', url: 'https://fonts.google.com/specimen/DM+Mono' },
];

export function LicensesRoute() {
  const { setCenter, setRight } = useLayoutSlots();
  useEffect(() => {
    setCenter(
      <article className={styles.page}>
        <h1>Open-source licenses</h1>
        <p>Fretnaught is built on the shoulders of these open-source projects:</p>
        <ul className={styles.licenseList}>
          {LICENSES.map((l) => (
            <li key={l.name}>
              <a href={l.url} target="_blank" rel="noopener noreferrer">
                {l.name}
              </a>{' '}
              — {l.license}
            </li>
          ))}
        </ul>
      </article>,
    );
    setRight(null);
    return () => {
      setCenter(null);
      setRight(null);
    };
  }, [setCenter, setRight]);
  return null;
}
